<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />

    <el-form ref="form" :model="formData" :disabled="formData.status == 1" label-width="120px">
      <el-form-item label="产品名称" prop="productName" :rules="rules">
        <el-input v-model="formData.productName" size="small" placeholder="请输入产品名称" />
      </el-form-item>

      <el-form-item label="产品logo" prop="productLogo" :rules="rules">
        <FileUpload :name.sync="formData.productLogo" :url="formData.productLogoUrl" />
      </el-form-item>

      <el-form-item label="产品类型" prop="productType" :rules="rules">
        <SelectDict v-model="formData.productType" dict-code="ProductType" />
      </el-form-item>

      <el-form-item label="供应商" prop="companyName" :rules="rules">
        <el-input v-model="formData.companyName" size="small" placeholder="请输入产品供应商" />
      </el-form-item>

      <el-form-item label="负责人姓名" prop="companyUserName" :rules="rules">
        <el-input v-model="formData.companyUserName" size="small" placeholder="请输入负责人姓名" />
      </el-form-item>

      <el-form-item label="负责人手机号" prop="companyUserMobile" :rules="rules">
        <el-input v-model="formData.companyUserMobile" size="small" placeholder="请输入负责人手机号" />
      </el-form-item>

      <el-form-item label="对接商务" prop="businessUserId" :rules="rules">
        <SelectAdmin v-model="formData.businessUserId" />
      </el-form-item>

      <el-form-item label="结算方式" prop="settleMethod" :rules="rules">
        <el-radio-group
            v-model="formData.settleMethod"
            placeholder="请选择结算方式"
            size="small"
        >
          <div v-for="item in settle_option_list" :key="item.value">
            <el-radio :label="item.value">
              <span style="display: inline-block;width: 20px;">{{ item.label }}</span>
              <el-input
                  v-model="item.inputValue"
                  :disabled="formData.settleMethod !== item.value"
                  :placeholder="item.placeholder"
                  style="width: 300px; margin-left: 15px"
                  size="small"
              />
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="结算备注" prop="settleRemark">
        <el-input v-model="formData.settleRemark" type="textarea" size="small" />
      </el-form-item>

      <el-form-item label="合作方式" prop="cooperationMethod" :rules="rules">
        <el-radio-group
            v-model="formData.cooperationMethod"
            placeholder="请选择合作方式"
            size="small"
        >
          <el-radio v-for="item in COOPERATION_METHOD_DICT" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="合作链接" :rules="rules" prop="cooperationUrl">
        <el-input v-model="formData.cooperationUrl" size="small" />
      </el-form-item>

      <el-form-item label="限额配置" prop="quota" class="quota">
        <el-select size="small" v-model="formData.quotaType" placeholder="请选择限额方式">
          <el-option
              v-for="item in quota_option_list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input v-model="formData.quotaValue" size="small" placeholder="请输入限额数值" style="margin-left: 10px;" />
      </el-form-item>

      <el-form-item label="产品权重" prop="productWeight" :rules="rules">
        <el-input v-model="formData.productWeight" size="small" placeholder="请输入产品权重" />
      </el-form-item>

<!--      <el-form-item label="产品特色" prop="productFeatureList">-->
<!--        <el-checkbox-group v-model="formData.productFeatureList" style="width:550px;">-->
<!--          <el-checkbox v-for="item in PRODUCT_FEATURE_DICT" :key="item" :label="item" :value="item" />-->
<!--        </el-checkbox-group>-->
<!--      </el-form-item>-->
      <el-form-item label="产品特色" prop="productFeatureList" :rules="rules">
        <SelectDict v-model="formData.productFeatureList" dict-code="ProductFeature" :multiple="true" />
      </el-form-item>

      <el-form-item label="推荐标签" prop="recommendTag" :rules="rules">
        <el-input v-model="formData.recommendTag" size="small" placeholder="请输入推荐标签（不超过6个字）" />
      </el-form-item>

      <el-form-item label="产品属性" :rules="rules" prop="productAttrList">
        <div v-for="item in product_attr_input_list" :key="item.attrCode">
          <span style="display: inline-block;width: 80px;">{{ item.attrName }}</span>
          <el-input
              v-model="item.inputValue"
              :placeholder="item.placeholder"
              style="width: 300px; margin-left: 15px"
              size="small"
          />
        </div>
      </el-form-item>

      <el-form-item label="" label-width="0" style="margin-top:20px;text-align:center;">
        <el-button type="primary" size="small" @click="save">提交</el-button>
        <el-button type="" size="small" @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
    <div style="height:50px"></div>
  </div>
</template>

<script>
import { editProductAPI, addProductAPI, getProductDetailAPI } from './api';
import { PRODUCT_CLIENT_DICT, COOPERATION_METHOD_DICT } from "@/enum/dict";
import FileUpload from '@/components/file-upload/index.vue';
import SelectAdmin from "@/views/components/select-admin.vue";
import SelectDict from "@/views/components/select-dict.vue";

const settle_option_list = [
  { label: "cpa", value: "cpa", inputValue: "", placeholder: "请输入单个注册用户结算金额" },
  { label: "cps", value: "cps", inputValue: "", placeholder: "请输入成交金额结算比例" },
  { label: "UV", value: "uv", inputValue: "", placeholder: "请输入UV结算价格" },
  { label: "PV", value: "pv", inputValue: "", placeholder: "请输入PV结算价格" },
];

const quota_option_list = [
  { label: "无", value: 0 },
  { label: "uv", value: 1 },
  { label: "注册", value: 2 },
];

const product_attr_input_list = [
  { attrCode: "fee_1", attrName: '可借额度', placeholder: "举例：200000", inputValue: "" },
  { attrCode: "rate_1", attrName: '年化利率', placeholder: "举例：3%-5%", inputValue: "" },
  { attrCode: "time_1", attrName: '借款期限', placeholder: "举例：1-36期", inputValue: "" },
];

export default {
  name: 'ProductAddOrEdit',
  components: { FileUpload, SelectAdmin, SelectDict },
  data() {
    return {
      PRODUCT_CLIENT_DICT,
      COOPERATION_METHOD_DICT,
      settle_option_list,
      quota_option_list,
      product_attr_input_list,
      formData: {
        productName: '',
        productLogo: '',
        productLogoUrl: '',
        productType: '',
        productWeight: undefined,
        companyName: '',
        companyUserName: '',
        companyUserMobile: '',
        businessUserId: undefined,
        settleMethod: undefined,
        settleValue: '',
        settleRemark: '',
        cooperationMethod: undefined,
        cooperationUrl: '',
        quotaType: undefined,
        quotaValue: '',
        productFeatureList: [],
        recommendTag: '',
        productAttrList: [],
      },
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
    }
  },
  mounted() {
    if (this.$route.params.id) this.getProductDetail();
  },
  computed: {
    settleValue() {
      const selectedOption = this.settle_option_list.find(option => option.value === this.formData.settleMethod);
      return selectedOption?.inputValue || '';
    },
  },
  methods: {
    // 产品详情
    async getProductDetail() {
      this.formData = await getProductDetailAPI(this.$route.params.id);
      // 结算方式
      for (let i = 0; i < this.settle_option_list.length; i++) {
        const settleOption = this.settle_option_list[i];
        if (settleOption.value === this.formData.settleMethod) {
          settleOption.inputValue = this.formData.settleValue;
          this.settle_option_list[i] = settleOption;
          break;
        }
      }
      // 产品属性
      const productAttrList = this.formData.productAttrList;
      for (let i = 0; i < this.product_attr_input_list.length; i++) {
        const tagi = this.product_attr_input_list[i];
        for (let j = 0; j < productAttrList.length; j++) {
          const tagj = productAttrList[j];
          if (tagi.attrCode === tagj.attrCode) {
            tagi.inputValue = tagj.attrValue;
            tagi.attrName = tagj.attrName;
            break;
          }
        }
      }
    },
    // 保存商品
    save() {
      this.formData.settleValue = this.settleValue;
      const productAttrList = [];
      for (let i = 0; i < this.product_attr_input_list.length; i++) {
        productAttrList[i] = {
          attrCode: this.product_attr_input_list[i].attrCode,
          attrValue: this.product_attr_input_list[i].inputValue,
        };
      }
      this.formData.productAttrList = productAttrList;
      console.log('@@save', this.formData);
      this.$refs.form.validate(() => {
        if (this.formData.id) {
          // 编辑
          editProductAPI(this.formData).then(() => {
            this.$message.success('编辑成功');
            this.$router.back();
          })
        } else {
          // 新增
          addProductAPI(this.formData).then(() => {
            this.$message.success('新增成功');
            this.$router.back();
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  .el-form /deep/ {
    .el-input,
    .el-textarea {
      width: 400px;
    }
    .el-radio__label {
      line-height: 3;
    }
    .quota {
      .el-input {
        width: 150px;
      }
    }
  }
}
</style>
